import React, { Component } from 'react';
import { compose } from 'recompose';
import Moment from 'react-moment';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import cellEditFactory from 'react-bootstrap-table2-editor'; 
import { Button, Form, Container, Segment, Image } from 'semantic-ui-react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';

import { withFirebase } from '../Firebase';
import { AuthUserContext, withAuthorization } from '../Session';
import * as ROLES from '../../constants/roles';
import * as ROUTES from '../../constants/routes';

const dateToFormat = new Date(); // e.g. Mon Apr 19 1976 09:59:00 GMT-0800
const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;
/*
const selectOptions = {
  0: 'good',
  1: 'Bad',
  2: 'unknown'
};
*/

const INITIAL_STATE = {
  faultID: '',
  faultDescription: '',
  faultCategory: '',
  faultOutlet: '',
  selectedRowIndex: '',

  feedbackID: '',
  feedbackCustomerName: '',
  feedbackCustomerEmail: '',
  feedbackOutlet: '',
  feedbackDescription: '',
  selectedRowIndexFeedback: '',

  selectedRowIndexResolvedReport: '',
};


const pagination = paginationFactory({
  sizePerPageList:[
    {
      text:'5', value:5
  }, {
      text:'10', value:10
  } ]
});

const columns = [{
  dataField: 'faultID',
  hidden: true,
  text: '# id',
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'dateSubmitted',
  text: 'Date',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultCategory',
  text: 'Category',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOutlet',
  text: 'Outlet',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultStatus',
  text: 'Status',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'markedAsRead',
  text: 'markedAsRead',
  editable: false,
  hidden: true,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}];

const columnsResolved = [{
  dataField: 'faultID',
  hidden: true, 
  text: '# id',
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'dateSubmitted',
  text: 'Date',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultCategory',
  text: 'Category',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOutlet',
  text: 'Outlet',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultStatus',
  text: 'Status',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}];

const columnsFeedback = [{
  dataField: 'feedbackID',
  hidden: true, 
  text: '# id',
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'dateSubmitted',
  text: 'Date',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'feedbackCustomerName',
  text: 'Name',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'feedbackOutlet',
  text: 'Outlet',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}];

class HomePage extends Component {
  constructor(props) {
    super(props);
 
    this.state = { 
      ...INITIAL_STATE 
    };
  }
  
  writeData = (row) => {
    this.props.firebase.doUpdateSelectedFaultReport(row.faultID, row.faultCategory, row.faultDescription, row.faultOutlet, row.faultStatus);
  };

  onSubmit = event => {
    const { faultID, faultCategory, faultDescription, faultOutlet } = this.state;
    const dateSubmitted = (new Date()).toLocaleString();
    this.props.firebase.doCreateNewFaultReport(dateSubmitted, faultID, faultCategory, faultDescription, faultOutlet);
    this.setState({ ...INITIAL_STATE });
    event.preventDefault();
    window.location.reload(false);
  };

  onSubmitFeedback = event => {
    const { feedbackID, feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet } = this.state;
    const dateSubmitted = (new Date()).toLocaleString();
    this.props.firebase.doCreateNewFeedback(dateSubmitted, feedbackID, feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet);
    this.setState({ ...INITIAL_STATE });
    event.preventDefault();
    window.location.reload(false);
  };

  onSubmitFaultOptionClicked = event => {
    this.props.firebase.setFaultID();
    console.log("Submit Fault Report Clicked");
    this.props.history.push({
      pathname: ROUTES.SUBMIT_REPORT_USER,
    })
  };

  onSubmitFeedbackOptionClicked = event => {
    this.props.firebase.setFeedbackID();
    console.log("Submit Feedback Report Clicked");
    this.props.history.push({
      pathname: ROUTES.SUBMIT_FEEDBACK_USER,
    })
  };

  viewSelectedReport = (uid, selectedRowIndex, faultReportObj) => {
    console.log("View Report for Row Index: ", selectedRowIndex);
    this.setState({selectedRowIndex:selectedRowIndex});
    if (selectedRowIndex === '') { // no report selected
      window.alert("No report selected. Please select a report from the table to view.");
    }
    else {
      this.props.firebase.doMarkAsReadByUserForSelectedFaultReport(uid, selectedRowIndex);
      this.props.history.push({
        pathname: ROUTES.REPORT_DETAILS_USER,
        state: { faultReport : faultReportObj }
      })
      window.location.reload(false);
    }
  };

  viewSelectedResolvedReport = (selectedRowIndexResolvedReport, faultReportObj) => {
    console.log("View Report for Row Index: ", selectedRowIndexResolvedReport);
    this.setState({selectedRowIndexResolvedReport:selectedRowIndexResolvedReport});
    if (selectedRowIndexResolvedReport === '') { // no report selected
      window.alert("No report selected. Please select a report from the table to view.");
    }
    else {
      this.props.history.push({
        pathname: ROUTES.REPORT_DETAILS_USER,
        state: { faultReport : faultReportObj }
      })
    }
  };

  viewSelectedFeedback = (selectedRowIndexFeedback, feedbackObj) => {
    console.log("View Feedback for Row Index: ", selectedRowIndexFeedback);
    this.setState({selectedRowIndexFeedback:selectedRowIndexFeedback});
    if (selectedRowIndexFeedback === '') { // no feedback selected
      window.alert("No feedback selected. Please select a feedback from the table to view.");
    }
    else {
      this.props.history.push({
        pathname: ROUTES.FEEDBACK_DETAILS_USER,
        state: { feedback : feedbackObj }
      })
    }
  };
 
  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeFeedback = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { faultID, faultCategory, faultDescription, faultOutlet } = this.state;
    const { feedbackID, feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet } = this.state;

    const isInvalid = faultID === '' || faultCategory === '' || faultDescription === '' || faultOutlet === '';
    const isInvalidFeedback = feedbackID === '' || feedbackCustomerName === '' || feedbackDescription === '' || feedbackOutlet === '';

    var selectedRowIndex = '';
    var selectedRowIndexFeedback = '';
    var selectedRowIndexResolvedReport = '';

    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      bgColor: '#491514',
      onSelect: (row, isSelect, rowIndex, e) => {
        console.log("Selected Table Row Index: ", row.faultID);
        console.log("Selected Table Row Index: ", row);
        selectedRowIndex = row.faultID;
      }
    };

    const selectRowResolvedReport = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      bgColor: '#491514',
      onSelect: (row, isSelect, rowIndex, e) => {
        console.log("Selected Table Row Index: ", row.faultID);
        selectedRowIndexResolvedReport = row.faultID;
      }
    };

    const selectRowFeedback = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      bgColor: '#491514',
      onSelect: (row, isSelect, rowIndex, e) => {
        console.log("Selected Table Row Index: ", row.feedbackID);
        selectedRowIndexFeedback = row.feedbackID;
      }
    };

    const rowStyle = (row, rowIndex) => {
      const style = {};
      if(row.markedAsRead === false){
        style.backgroundColor = '#999900'; //yellow row is not yet read by user
      }else{
      }
      return style;
    };


    return (
      <AuthUserContext.Consumer>
      {authUser => (
        <Container>
          <hr/>
          <Container>
          <div class="ui inverted fluid segment">
          <Image src='\Images\bch_logo_small.png' size='small' floated='right' />
          <p></p>
          <Moment format="dddd, D MMM YYYY, hh:mm:ss a" date={dateToFormat} />
          <h1>Welcome {authUser.username}</h1>
          <p></p>
          </div>
          </Container>

          <Container>
          <Tabs>
            <TabList style={{ backgroundColor:'black', textAlign:'center'}}>
            <Tab>Fault</Tab>
            <Tab>Feedback</Tab>
            <Tab>Resolved</Tab>
            </TabList>

            <TabPanel>
              <p></p>
              <button class="ui inverted green button fluid" type="click" onClick={()=>{this.onSubmitFaultOptionClicked()}}>Submit New Report</button>
              <p></p>
              <div class="ui inverted segment">
              <ToolkitProvider
                keyField="faultID"
                data={ (authUser.faultReports == null) ? [] : Object.keys(authUser.faultReports).map(key => ({
                  ...authUser.faultReports[key]
                })) }
                columns={ columns }
                striped
                hover
                condensed
                search
              >
                  {
                    props => (
                      <div>
                        <SearchBar { ...props.searchProps } />
                        <BootstrapTable { ...props.baseProps } 
                                        selectRow={ selectRow }
                                        rowStyle={rowStyle}
                                        pagination= {pagination}
                                        />
                        <Button floated='right' positive size="small" type="click" onClick={()=>{this.viewSelectedReport(authUser.uid, selectedRowIndex, 
                          authUser.faultReports[String(selectedRowIndex)]);}}>View</Button>
                        <p></p>
                        <div class="customFontSmall" id="totalFaultNum">Total number of Fault Reports: { authUser.faultReports == null ? 0 : (authUser.faultReports).length }</div>
                      </div>
                    )
                  }
              </ToolkitProvider>
              </div>
            </TabPanel>

            <TabPanel>
              <p></p>
              <button class="ui inverted green button fluid" type="click" onClick={()=>{this.onSubmitFeedbackOptionClicked()}}>Submit New Feedback</button>
              <p></p>
              <div class="ui inverted segment">
              <ToolkitProvider
                keyField="feedbackID"
                data={ (authUser.feedback == null) ? [] : Object.keys(authUser.feedback).map(key => ({
                  ...authUser.feedback[key]
                })) }
                columns={ columnsFeedback }
                striped
                hover
                condensed
                search
              >
                  {
                    props => (
                      <div>
                        <SearchBar { ...props.searchProps } />
                        <BootstrapTable { ...props.baseProps } 
                                        selectRow={ selectRowFeedback }
                                        pagination= {pagination}
                                        />
                          <Button floated='right' positive size="small" type="click" onClick={()=>{this.viewSelectedFeedback(selectedRowIndexFeedback, 
                            authUser.feedback[String(selectedRowIndexFeedback)]);}}>View</Button>
                        <p></p>
                        <div class="customFontSmall" id="totalFeedbackNum">Total number of Feedback: { authUser.feedback == null ? 0 : (authUser.feedback).length }</div>
                      </div>
                    )
                  }
              </ToolkitProvider>
              </div>
            </TabPanel>

            <TabPanel>
              <p></p>
              <div class="ui inverted fluid segment">
              <ToolkitProvider
                keyField="faultID"
                data={ (authUser.resolvedReports == null) ? [] : Object.keys(authUser.resolvedReports).map(key => ({
                  ...authUser.resolvedReports[key]
                })) }
                columns={ columnsResolved }
                striped
                hover
                condensed
                search
              >
                  {
                    props => (
                      <div>
                        <SearchBar { ...props.searchProps } />
                        <BootstrapTable { ...props.baseProps } 
                                        selectRow={ selectRowResolvedReport }
                                        pagination={pagination}
                                        />
                          <Button floated='right' positive size="small" type="click" onClick={()=>{this.viewSelectedResolvedReport(selectedRowIndexResolvedReport, 
                            authUser.resolvedReports[String(selectedRowIndexResolvedReport)]);}}>View</Button>
                        <p></p>
                        <div class="customFontSmall">Total number of Resolved Reports: { authUser.resolvedReports == null ? 0 : (authUser.resolvedReports).length }</div>
                      </div>
                    )
                  }
              </ToolkitProvider>
              </div>
          </TabPanel>
          </Tabs>
        </Container>
        </Container>
      )}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = authUser => authUser && !!authUser.isNewUser === false && !!authUser.roles[ROLES.USER];
 
export default compose(
  withAuthorization(condition),
  withFirebase,
)(HomePage);